import styled from 'styled-components';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';

import TabNavigation from '../../shared/TabNavigation';
import Deliver from './components/Deliver';
import Automate from './components/Automate';
import FollowUps from './components/FollowUps';
import BoardShareLink from './components/BoardShareLink';
import i18n from '../../app/i18n';

const tabs = [
  { name: i18n.t('send:navigation.deliver'), to: 'tab-deliver', exact: true },
  { name: i18n.t('send:navigation.automate'), to: 'tab-automate' },
  { name: i18n.t('send:navigation.followUps'), to: 'tab-follow-ups' },
  {
    name: i18n.t('send:navigation.boardShareLink'),
    to: 'tab-board-share-link',
  },
];

const SendContainer = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
`;

export default function Send({ emailPreviewPath, smsPreviewPath }) {
  return (
    <SendContainer>
      <HashRouter hashType="noslash">
        <TabNavigation tabs={tabs} />

        <Switch>
          <Route exact path="/">
            <Redirect to="/tab-deliver" />
          </Route>
          <Route path="/tab-deliver">
            <Deliver
              emailPreviewPath={emailPreviewPath}
              smsPreviewPath={smsPreviewPath}
            />
          </Route>
          <Route path="/tab-automate">
            <Automate />
          </Route>
          <Route path="/tab-follow-ups">
            <FollowUps />
          </Route>
          <Route path="/tab-board-share-link">
            <BoardShareLink />
          </Route>
        </Switch>
      </HashRouter>
    </SendContainer>
  );
}
